import React, { useContext, useRef } from 'react';
import { Link } from "react-router-dom";
import { localizeArt } from './../localize.js';
import MyUserContext from './../myUserContext.js';
import PlatformRatings from './PlatformRatings';
// import ArtTabs from './ArtTabs';
import ArtThumbnail from './ArtThumbnail'; // Import ArtThumbnail

const CATEGORY_ENUM = {
  1: "movie",
  2: "videoGame",
  3: "book"
};

const ImageScroller = ({
  arts,
  categories = ["movie", "book", "videoGame"],
  showCategoryTitles = true,
  aiReasonedArts = [],
  basedOnRecentLogbookArts = []
}) => {
  const myUser = useContext(MyUserContext);
  const language = myUser ? myUser.myUserSettings.lang : 'ru';
  const scrollerRefs = useRef({});

  const scrollByAmount = (cat, direction) => {
    const scroller = scrollerRefs.current[cat];
    if (!scroller) return;
    const amount = Math.round(scroller.clientWidth * 0.8);
    scroller.scrollBy({ left: direction * amount, behavior: "smooth" });
  };

  return (
    <div className="space-y-8">
      {categories.map((cat) => {
        const filteredArts = arts.filter(
          (item) => CATEGORY_ENUM[item.category] === cat
        );

        if (filteredArts.length === 0) return null;

        return (
          <div key={cat} className="space-y-3">
            {/* Category title */}
            {showCategoryTitles && (
              <div className="flex justify-center font-semibold capitalize mt-3 text-gray-200">
                {cat === "movie"
                  ? (language === "ru" ? "Фильмы" : "Movies")
                  : cat === "book"
                  ? (language === "ru" ? "Книги" : "Books")
                  : (language === "ru" ? "Игры" : "Video Games")}
              </div>
            )}

            {/* Two-row carousel */}
            <div className="relative">
              <button
                type="button"
                aria-label="Scroll left"
                className="hidden md:flex absolute left-1 top-1/2 -translate-y-1/2 z-10 h-12 w-12 items-center justify-center rounded-full bg-black/70 text-white text-3xl shadow-md hover:bg-black/90"
                onClick={() => scrollByAmount(cat, -1)}
              >
                ‹
              </button>
              <div
                ref={(el) => { scrollerRefs.current[cat] = el; }}
                className="grid grid-rows-2 grid-flow-col auto-cols-max gap-4 overflow-x-auto pb-2 pr-6 snap-x snap-mandatory"
                style={{ scrollbarWidth: "none" }}
              >
                {filteredArts.map((item, index) => {
                  const localizedArt = localizeArt(item, language);
                  const rawDescription = (localizedArt.description || "").trim();
                  const sentences = rawDescription.match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [];
                  const firstSentences = sentences.slice(0, 3).join(" ").trim();
                  let description = firstSentences || rawDescription;
                  if (description.length > 150) {
                    description = `${description.slice(0, 147).trim()}...`;
                  }
                  return (
                  <div key={index + item.id} className="snap-start">
                    <Link to={`/arts/${item.id}`} className="group block w-40">
                      <div className="rounded-xl overflow-hidden bg-[#2a2b2c] shadow-sm transition-transform duration-200 group-hover:-translate-y-1 group-hover:shadow-lg">
                        <ArtThumbnail art={item} />
                      </div>
                      <div className="mt-2 text-center">
                        <div className="truncate text-xs text-gray-100">
                          {localizedArt.name}
                        </div>
                        {description && (
                          <div className="mt-1 text-[11px] text-gray-400 leading-snug">
                            {description}
                          </div>
                        )}
                      </div>
                    </Link>
                    <div className="mt-2 flex justify-center">
                      <PlatformRatings art={item} />
                    </div>
                    {aiReasonedArts.includes(item.id) && (
                      <div className="flex justify-center text-center text-bold text-blue-400 text-xs md:text-sm">
                        <b>{language === "ru" ? "Получено от ИИ с мышлением" : "Based on AI reasoning"}</b>
                      </div>
                    )}
                    {basedOnRecentLogbookArts.includes(item.id) && (
                      <div className="flex justify-center text-center text-bold text-yellow-400 text-xs md:text-sm">
                        <b>{language === "ru" ? "На основе недавнего из журнала" : "Based on recent logbook"}</b>
                      </div>
                    )}
                  </div>
                )})}
              </div>
              <button
                type="button"
                aria-label="Scroll right"
                className="hidden md:flex absolute right-1 top-1/2 -translate-y-1/2 z-10 h-12 w-12 items-center justify-center rounded-full bg-black/70 text-white text-3xl shadow-md hover:bg-black/90"
                onClick={() => scrollByAmount(cat, 1)}
              >
                ›
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ImageScroller;
